import axios, { AxiosInstance } from "axios";
import {
  IAuthTokens,
  TokenRefreshRequest,
  useAuthTokenInterceptor
} from "axios-jwt";

const refreshEndpoint = "/auth/refresh";
const requestRefresh: TokenRefreshRequest = async (
  refreshToken: string
): Promise<string> => {
  // perform refresh
  return (
    await axios.post<IAuthTokens>(refreshEndpoint, { token: refreshToken })
  ).data.accessToken;
};

let client: AxiosInstance;
export const setClientAuthentication = (token: string): AxiosInstance => {
  console.log(
    "${process.env.VUE_APP_BOOST_NOW_BASE_URL} is ",
    process.env.VUE_APP_BOOST_NOW_BASE_URL
  );
  client = axios.create({
    baseURL: `${process.env.VUE_APP_BOOST_NOW_BASE_URL}/admin/boost_now/`,
    responseType: "json",
    headers: {
      "Content-Type": "application/json",
      "X-Itsdangerous": token
    }
  });
  // add interceptor to axios instance
  useAuthTokenInterceptor(client, { requestRefresh });
  return client;
};

export const getClient = () => client;
